export default "__VITE_ASSET__qAmTCB92__"